import React, { Component } from 'react';
import { connect } from 'react-redux';
import { currentWidget } from '../../../../action/action';
import { notificationColorConfig } from '../../../JS/colorConfig';
import { Link } from "react-router-dom";

class NewMessage extends Component{

    constructor(props){
        super(props);
    }

    componentWillUnmount(){
        this.props.currentWidget({})
    }

    componentDidUpdate(){
        notificationColorConfig(this.props.menuColor);
    }


    componentDidMount(){
        this.props.currentWidget({widgetType:true});
    }

    render(){
        return(
            <div>
                <header className="inner-pages w-footer no-bg">
                    <Link exact to = "/notifications" className="button-back"></Link>
                    <div className="heading">
                        <h1>Write Message</h1>
                    </div> 
                </header>
                <section id="notifications" className="widgets">
                    <div className="widgets msg-section margin-top-1">
                        <form>
                            <div className="form-row">
                                <label for="send-to">To</label>
                                <div className="custom-select">
                                    <select id="send-to">
                                        <option selected="">Please select</option>
                                        <option>Front Desk</option>
                                        <option>Restaurant</option>
                                        <option>Pool Admin</option>
                                        <option>Room Attendants</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-row">
                                <label for="message-contents" style = {{marginBottom:"20px"}}>Message</label>
                                <textarea id="message-contents" className="message-contents" rows="10" placeholder="Type your message here"></textarea>
                            </div>
                        </form>
                    </div>
                </section>
                <footer className="button-controls">
                    <section className="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                        <button className="primary w-100 all-caps">Send</button>
                    </section>
                </footer>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
      menuColor: state.store.home.MenuColor,
    }
  }



export default connect(mapStateToProps,{currentWidget})(NewMessage);